import { toCsv } from './toCsv';
import { downloadBlob } from './downloadFile';
import { sanitizeFilenamePart } from './downloadJson';

const SKIP_KEYS = new Set(['reviews', 'input']);

export function parseNdjson(text) {
  const src = String(text || '').trim();
  if (!src) return [];
  if (src.startsWith('[')) {
    try { const arr = JSON.parse(src); if (Array.isArray(arr)) return arr.filter(r => r && typeof r === 'object'); } catch (_) { /* NDJSON으로 */ }
  }
  const out = [];
  for (const line of src.split('\n')) {
    const l = line.trim();
    if (!l) continue;
    try { const r = JSON.parse(l); if (r && typeof r === 'object') out.push(r); } catch (_) { /* 무시 */ }
  }
  return out;
}

function cell(v) {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) return v;
  if (typeof v === 'object') return JSON.stringify(v);
  return v;
}

// 상품 × 리뷰 1행. 컬럼은 전체 레코드의 키 합집합(등장 순서 유지).
export function flattenForCsv(records) {
  const productKeys = [];
  const reviewKeys = [];
  const seenP = new Set(); const seenR = new Set();
  for (const r of records) {
    for (const k of Object.keys(r)) if (!SKIP_KEYS.has(k) && !seenP.has(k)) { seenP.add(k); productKeys.push(k); }
    for (const rv of (Array.isArray(r.reviews) ? r.reviews : [])) {
      if (!rv || typeof rv !== 'object') continue;
      for (const k of Object.keys(rv)) if (!seenR.has(k)) { seenR.add(k); reviewKeys.push(k); }
    }
  }
  const rows = [];
  for (const r of records) {
    const base = {};
    for (const k of productKeys) base[k] = cell(r[k]);
    const reviews = Array.isArray(r.reviews) && r.reviews.length ? r.reviews : [null];
    for (const rv of reviews) {
      const row = { ...base };
      for (const k of reviewKeys) row[`review_${k}`] = cell(rv ? rv[k] : undefined);
      rows.push(row);
    }
  }
  return rows;
}

function baseName(site, keyword, id) {
  return `reviews_${site}_${sanitizeFilenamePart(keyword)}_${id}`;
}

export function downloadReviewJson(records, site, keyword, id) {
  downloadBlob(JSON.stringify(records, null, 2), `${baseName(site, keyword, id)}.json`, 'application/json');
}

export function downloadReviewCsv(records, site, keyword, id) {
  downloadBlob(toCsv(flattenForCsv(records)), `${baseName(site, keyword, id)}.csv`, 'text/csv;charset=utf-8');
}
